import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactS3Uploader from 'react-s3-uploader'

import { createDocument, getSignedUrl, setDocUploadStartTime } from '../actions/documents'
import { tagPageview, tagFunnel } from '../actions/tagmanager'
import { toggle } from '../actions/ui'
import { pollingBegin } from '../actions/polling'
import Button from '../components/base/Button'
import Icon from '../components/base/Icon'
import { MY_COMPUTER } from '../util/dataTestIds'

export class DocumentUpload extends Component {
  constructor() {
    super()
    this.checkFile = this.checkFile.bind(this)
  }

  checkFile(file, next) {
    const { uploadConfig } = this.props
    const fileExtension = `.${file.name.split('.').pop()}`

    if (uploadConfig.extensions.indexOf(fileExtension) === -1) {
      this.props.showError('alertFileType')
      return
    }

    if (file.size > uploadConfig.filesize.min && file.size > uploadConfig.filesize.max) {
      this.props.showError('alertFileSize')
      return
    }

    this.props.openCheckModal()
    next(file)
  }

  render() {
    const { handleCreate, handleGetSignedUrl, uploadConfig, theme } = this.props
    let extensions
    let mimeTypes
    if (uploadConfig) {
      extensions = uploadConfig.extensions.join(',')
      mimeTypes = uploadConfig.mimeTypes.join(',')
    }
    return (
      <Button
        theme={theme}
        id="upload-computer"
        tagname="div"
        halfWidth
        inverted
        fileUpload
        disabled={!uploadConfig}
        data-test-id={MY_COMPUTER}
      >
        <Icon name="laptop" size="16" />
        <span>It&apos;s on my computer</span>
        {uploadConfig && (
          <ReactS3Uploader
            id="upload_computer"
            onClick={() => this.props.tagFunnel('upload paper', 'on my computer')}
            accept={`${extensions}, ${mimeTypes}`}
            preprocess={(file, next) => this.checkFile(file, next)}
            onFinish={data => handleCreate(data)}
            getSignedUrl={(file, callback) => handleGetSignedUrl(file).then(callback)}
            uploadRequestHeaders={{}}
          />
        )}
      </Button>
    )
  }
}

DocumentUpload.propTypes = {
  handleCreate: PropTypes.func.isRequired,
  handleGetSignedUrl: PropTypes.func.isRequired,
  openCheckModal: PropTypes.func.isRequired,
  uploadConfig: PropTypes.shape({
    mimeTypes: PropTypes.arrayOf(PropTypes.string),
    extensions: PropTypes.arrayOf(PropTypes.string),
    filesize: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
    averageDuration: PropTypes.number,
  }),
  tagFunnel: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
}

DocumentUpload.defaultProps = {
  uploadConfig: undefined,
}

const mapStateToProps = state => ({
  uploadConfig: state.app.upload,
  theme: state.theme,
})

const mapDispatchToProps = dispatch => ({
  openCheckModal: () => {
    dispatch(tagPageview('/virtual-pageview/paperchecker/processing-your-paper'))
    dispatch(pollingBegin('create'))
    dispatch(setDocUploadStartTime())
  },
  showError: key => dispatch(toggle(key, true)),
  // instead of stale reference to uploadStartTime in react component, createDocument action
  // retrieves second argument from store
  handleCreate: data => dispatch(createDocument(data, null)),
  handleGetSignedUrl: file => dispatch(getSignedUrl(file, { type: 'file' })),
  tagFunnel: (eventName, eventAction) => {
    dispatch(tagFunnel(eventName, eventAction))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload)
